import EnhancementPage from 'pages/EnhancementPage/EnhancementPage'

export default EnhancementPage
